(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hlth-band-approach"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTP(root) {
    if (!root || root.__tpInit) return;
    root.__tpInit = true;

    var track = root.querySelector('[data-tp-track]');
    if (!track) return;
    var prev = root.querySelector('.tp__nav--prev');
    var next = root.querySelector('.tp__nav--next');

    var originals = Array.prototype.slice.call(track.querySelectorAll('.tp__card'));
    var n = originals.length;
    if (!n) return;

    var DUR = 450; // ms — slide duration
    var pos = 0;
    var animating = false;
    var cloned = false;

    function perView() {
      var v = parseInt(getComputedStyle(root).getPropertyValue('--tp-per'), 10);
      return v > 0 ? v : 1;
    }
    function loopable() { return n > perView(); }

    // Append a clone of every card once, so sliding past the last card reveals
    // the first ones seamlessly (matches the Trustpilot infinite carousel).
    function ensureClones() {
      if (cloned || !loopable()) return;
      originals.forEach(function (c) {
        var cl = c.cloneNode(true);
        cl.classList.add('tp__card--clone');
        cl.setAttribute('aria-hidden', 'true');
        cl.removeAttribute('id');
        track.appendChild(cl);
      });
      cloned = true;
    }

    function step() {
      var card = track.querySelector('.tp__card');
      if (!card) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function apply(animate) {
      track.style.transition = animate ? ('transform ' + DUR + 'ms cubic-bezier(.4,.0,.2,1)') : 'none';
      track.style.transform = 'translateX(' + (-pos * step()) + 'px)';
    }
    function syncNav() {
      var off = !loopable();
      [prev, next].forEach(function (b) {
        if (!b) return;
        b.style.display = off ? 'none' : '';
      });
    }

    function goNext() {
      if (animating || !loopable()) return;
      ensureClones();
      animating = true;
      pos++;
      apply(true);
    }
    function goPrev() {
      if (animating || !loopable()) return;
      ensureClones();
      animating = true;
      if (pos <= 0) {
        // Jump (no transition) to the mirror position, then slide back one.
        pos = n;
        apply(false);
        void track.offsetWidth; // force reflow so the jump commits first
      }
      pos--;
      apply(true);
    }

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      animating = false;
      if (pos >= n) { pos -= n; apply(false); }
      else if (pos < 0) { pos += n; apply(false); }
    });

    if (next) next.addEventListener('click', goNext);
    if (prev) prev.addEventListener('click', goPrev);

    // Touch / pointer swipe.
    var dragStartX = null, dragX = null, dragging = false, base = 0;
    track.addEventListener('touchstart', function (e) {
      if (animating || !loopable()) return;
      dragging = true;
      dragStartX = e.touches[0].clientX;
      dragX = dragStartX;
      base = -pos * step();
      track.style.transition = 'none';
      stopAuto();
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dragX = e.touches[0].clientX;
      track.style.transform = 'translateX(' + (base + (dragX - dragStartX)) + 'px)';
    }, { passive: true });
    track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      var dx = (dragX || dragStartX) - dragStartX;
      var threshold = step() * 0.18;
      if (dx <= -threshold) goNext();
      else if (dx >= threshold) goPrev();
      else apply(true);
      startAuto();
    });

    // Autoplay.
    var delay = parseInt(root.getAttribute('data-tp-autoplay'), 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    function startAuto() {
      if (!delay || reduce || !loopable()) return;
      stopAuto();
      timer = setInterval(goNext, delay);
    }
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    root.addEventListener('focusin', stopAuto);
    root.addEventListener('focusout', startAuto);

    // Reposition on resize (card width / per-view changes).
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (!loopable()) { pos = 0; }
        apply(false);
        syncNav();
        if (timer) startAuto(); else startAuto();
      }, 150);
    });

    syncNav();
    apply(false);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? startAuto() : stopAuto(); });
      }, { threshold: 0.2 }).observe(root);
    } else {
      startAuto();
    }
  }

  function initAll() { document.querySelectorAll('[data-tp]').forEach(initTP); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-tp]');
    if (root) { root.__tpInit = false; initTP(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
